module.exports = __webpack_public_path__ + "static/img/courtneysobkow_circle150.7ce908b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/courtneysobkow_circle150.png
// module id = 1hhs
// module chunks = 0